<template>
  <div>
    <!-- 页头 -->
    <header class="post-head">
      <div class="post-head-inner">
        <div class="post-eyebrow" v-if="article.category && article.category.id">
          {{ article.category.name }}
        </div>
        <h1 class="post-title">{{ article.title }}</h1>
        <div class="post-meta">
          <span>{{ article.createTime | date }}</span>
          <span
            v-if="article.lastTime && article.lastTime !== article.createTime"
          >
            更新于 {{ article.lastTime | date }}
          </span>
          <span v-if="wordNum">{{ wordNum | num }} 字</span>
          <span v-if="readTime">约 {{ readTime }}</span>
          <span v-if="article.quantity">{{ article.quantity }} 次阅读</span>
        </div>
      </div>
    </header>
    <!-- 内容 -->
    <v-row class="post-container">
      <v-col md="9" cols="12">
        <div class="post-wrapper">
          <article
            v-show="!isCheck"
            id="write"
            class="article-content markdown-body"
            v-html="article.content"
            ref="article"
          />
          <div style="" v-show="isCheck">
            该文章为私密文章，如需查看请点
            <a
              href="javaScript:void(0);"
              @click="dialogVisible = true"
              style="color: red"
            >
              <i class="el-icon-lock"></i>此处
            </a>
            获取验证码
          </div>
          <!-- 收尾：回到故事页 -->
          <div class="post-tail">
            <router-link class="back-story" to="/story">
              &larr; 返回我的故事
            </router-link>
          </div>
        </div>
      </v-col>
      <!-- 侧边功能 -->
      <v-col md="3" cols="12" class="d-md-block d-none">
        <div style="position: sticky; top: 90px;">
          <!-- 文章目录 -->
          <div class="right-container">
            <div class="right-title">目录</div>
            <div id="toc" />
          </div>
        </div>
      </v-col>
    </v-row>
    <div>
      <el-dialog title="加载校验" :visible.sync="dialogVisible" width="30%">
        <div style="display :flex;justify-content: center;">
          <font
            >扫码关注公众号「<span style="color: #005cc5">雄雄的小课堂</span
            >」</font
          ><br />
        </div>
        <div style="display :flex;justify-content: center;">
          <font>
            回复 「<span style="color: red">验证码</span>」获取验证码</font
          >
        </div>
        <div style="display :flex;justify-content: center;">
          <img
            style="width: 50%;height: 50%"
            src="http://img.shiyit.com/gzh-qrcode.jpg"
          />
        </div>
        <el-input
          v-model="code"
          oninput="value=value.replace(/[^\d]/g,'')"
          placeholder="请输入6位数的验证码"
          style="display :flex;justify-content: center;width: 45%;margin: 0 auto;"
        ></el-input>
        <span style="display :flex;justify-content: center;">
          <el-button
            style="width: 45%;margin-top: 5px"
            type="primary"
            @click="checkSecret"
            >提 交</el-button
          >
        </span>
      </el-dialog>
    </div>

    <!--分享海报的弹出层-->
    <el-dialog
      width="20%"
      height="200px"
      center
      :visible.sync="dialogFengXiang"
    >
      <!-- 海报html元素 -->
      <div id="posterHtml" v-show="isShowBg" :style="fxbg">
        <div class="fx_content ">
          <span style="color: #000000;font-size: 16px">{{ posterTitle }}</span>
          <p style="font-size: 12px;">
            关注微信公众号【雄雄的小课堂】;
            <br />
            博客网址：https://www.穆雄雄.com
          </p>
        </div>
        <!-- 二维码 -->
        <div id="qrcodeImg" ref="qrcodeImg"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import tocbot from "tocbot";
import {
  getArticleInfo,
  fetchComments,
  like,
  checkSecret,
  getSing
} from "../../api";

import wx from "weixin-js-sdk"; // 引入wxjs
/*引入二维码*/
import QRCode from "qrcodejs2";
//html转换成canvas
import html2canvas from "html2canvas";

export default {
  data: function() {
    return {
      config: {
        sites: ["qzone", "wechat", "weibo", "qq"]
      },
      imgList: [],
      articleId: this.$route.params.articleId,
      dialogVisible: false,
      code: null,
      isCheck: false,
      article: {
        nextArticle: {
          id: 0,
          articleCover: ""
        },
        lastArticle: {
          id: 0,
          articleCover: ""
        },
        category: {
          id: 0,
          name: ""
        },
        recommendArticleList: [],
        newestArticleList: [],
        //文章标题
        title: ""
      },
      commentList: [],
      count: 0,
      wordNum: "",
      readTime: "",
      articleHref: window.location.href,
      img: process.env.VUE_APP_IMG_API,
      clipboard: null,
      // 文案标题
      posterTitle: "",
      // 文案内容
      posterContent: "",
      // 最终生成的海报图片
      posterImg: "",
      isShowBg: false,
      //是否显示对话框
      dialogFengXiang: false,
      //背景图
      fxbg: ""
    };
  },
  // 每篇文章要有自己的 title 和描述，否则 63 篇文章在搜索引擎里是同一张脸
  metaInfo() {
    const a = this.article || {};
    const title = a.title ? a.title + " - 穆雄雄" : "文章 - 穆雄雄";
    const desc = this.metaDescription;
    const kw = this.metaKeywords;
    const url = "https://www.88688.team/articles/" + this.articleId;
    return {
      title: title,
      meta: [
        { name: "keywords", content: kw },
        { name: "description", content: desc },
        { property: "og:type", content: "article" },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
        { property: "og:image", content: this.metaImage },
        { name: "twitter:card", content: "summary_large_image" }
      ],
      link: [{ rel: "canonical", href: url }]
    };
  },
  created() {
    this.getArticle();

    // 调用分享的事件
    setTimeout(() => {
      this.getShareInfo();
    }, 200);
  },
  /* destroyed() {
     this.clipboard.destroy();
     tocbot.destroy();
   },*/

  methods: {
    //随机生成背景图
    getRandomBg() {
      let path = process.env.VUE_APP_IMG_API;
      let max = 10;
      let random = Math.floor(Math.random() * max) + 1;
      let img_url = path + "fx-bg" + random + ".png";
      this.fxbg = { backgroundImage: "url(" + img_url + ")" };
    },

    //分享的功能
    fenxiang() {
      //生成随机背景图
      this.getRandomBg();
      //生成海报
      this.createPoster();
      //生成二维码
      this.createQrcode();
      this.dialogFengXiang = true;
    },

    // 生成二维码
    createQrcode() {
      this.$refs.qrcodeImg = "";
      setTimeout(() => {
        // 生成二维码
        new QRCode(this.$refs.qrcodeImg, {
          text: this.articleHref,
          width: 75,
          height: 75,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      }, 200);
      // qrcode.makeCode(text);
    },

    //生成海报
    createPoster() {
      // 生成海报
      const vm = this;
      //重新弄一下标题
      //let content = this.article.content.substring(0,110);
      /*let content = "";
      this.posterContent = content+"....";*/

      this.posterTitle = this.article.title.substring(0, 12) + "....";
      const domObj = document.getElementById("posterHtml");
      //显示海报
      this.isShowBg = true;
      html2canvas(domObj, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        onclone(doc) {
          let e = doc.querySelector("#posterHtml");
          e.style.display = "block";
        }
      }).then(function(canvas) {
        // 在微信里,可长按保存或转发
        vm.posterImg = canvas.toDataURL("image/png");
      });
    },

    //分享成小卡片(链接)
    getShareInfo() {
      //获取url链接
      //var url = encodeURIComponent(window.location.href.split("#")[0]);
      let currentUrl = window.location.href;
      /*getSing(currentUrl)
        .then(res => {
          if (res) {
            let obj = {
              appId: res.data.appId,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              timestamp: parseInt(res.data.timestamp),
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ]
            };
            let shareData = {
              title: "这是个标题",
              desc: "https://www.穆雄雄.com",
              link: currentUrl,
              imgUrl:
                "https://blogobs.88688.team/blog/643ab501f3ce4f7b93db3fb10e661c55.png"
            };
            wexinShare(obj, shareData);
          } else {
            alert("获取sdk参数失败");
          }
        })
        .catch(err => {
          alert("获取数据失败");
        });*/

      getSing(currentUrl).then(res => {
        let that = this;
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          // 必填，公众号的唯一标识
          appId: res.data.appId,
          // 必填，生成签名的时间戳
          timestamp: res.data.timestamp,
          // 必填，生成签名的随机串
          nonceStr: res.data.nonceStr,
          // 必填，签名
          signature: res.data.signature,
          // 必填，需要使用的 JS 接口列表
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
        });
        wx.ready(() => {
          var shareData = {
            title: that.article.title,
            desc: that.article.title,
            link: window.location.href,
            imgUrl: "https://cdnobs.16888.team/mxx-blognew/blog/l-logo-y.jpg"
          };
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
          wx.updateAppMessageShareData(shareData);
          //自定义“分享到朋友圈”及“分享到 QQ 空间”按钮的分享内容（1.4.0）
          wx.updateTimelineShareData(shareData);
        });
        //错误了会走 这里
        wx.error(function(res) {
          //console.log("微信分享错误信息", res);
          console.log("微信分享错误信息", res.errMsg);
        });
      });
    },

    checkSecret: function() {
      if (this.code == null || this.code.length !== 6) {
        this.$toast({ type: "error", message: "请输入有效的验证码" });
        return false;
      }
      checkSecret({ code: this.code })
        .then(res => {
          this.isCheck = false;
          this.dialogVisible = false;
          this.code = null;
        })
        .catch(err => {
          this.$toast({ type: "error", message: err.message });
        });
    },
    getArticle() {
      const that = this;
      //查询文章
      getArticleInfo(this.articleId).then(res => {
        // 文章不存在或已下线时不留空壳页，直接回首页
        if (!res.data || !res.data.title) {
          that.$router.replace("/");
          return;
        }
        document.title = res.data.title;
        that.article.title = res.data.title;
        if (res.data.keywords != null) {
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute("content", res.data.keywords);
        }
        this.isCheck = res.data.isSecret !== 0;
        //将markdown转换为Html
        this.markdownToHtml(res.data);
        this.$nextTick(() => {
          // 统计文章字数
          this.wordNum = this.deleteHTMLTag(this.article.content).length;
          // 计算阅读时间
          this.readTime = Math.round(this.wordNum / 400) + "分钟";
          // 添加代码复制功能
          this.clipboard = new Clipboard(".copy-btn");
          this.clipboard.on("success", () => {
            this.$toast({ type: "success", message: "复制成功" });
          });
          // 添加文章生成目录功能
          let nodes = this.$refs.article.children;
          if (nodes.length) {
            for (let i = 0; i < nodes.length; i++) {
              let node = nodes[i];
              let reg = /^H[1-4]{1}$/;
              if (reg.exec(node.tagName)) {
                node.id = i;
              }
            }
          }
          tocbot.init({
            tocSelector: "#toc", //要把目录添加元素位置，支持选择器
            contentSelector: ".article-content", //获取html的元素
            headingSelector: "h1, h2, h3,h4", //要显示的id的目录
            hasInnerContainers: true,
            onClick: function(e) {
              e.preventDefault();
            }
          });
          // 添加图片预览功能
          const imgList = this.$refs.article.getElementsByTagName("img");
          for (var i = 0; i < imgList.length; i++) {
            this.imgList.push(imgList[i].src);
            imgList[i].addEventListener("click", function(e) {
              that.previewImg(e.target.currentSrc);
            });
          }
        });
      });
    },
    listComment() {
      fetchComments({
        pageNo: 1,
        pageSize: 10,
        articleId: this.articleId
      }).then(res => {
        this.commentList = res.data != null ? res.data.commentDTOList : [];
        this.count = res.data != null ? res.data.commentCount : 0;
      });
    },
    /*点赞*/
    like() {
      // 判断登录
      //修改2022年12月10日14:01:40   不用登录也能点赞
      /*if (!this.$store.state.userId) {
        this.$store.state.loginFlag = true;
        return false;
      }*/
      //发送请求
      like(this.article.id).then(res => {
        //判断是否点赞
        if (this.$store.state.articleLikeSet.indexOf(this.article.id) != -1) {
          this.$set(this.article, "likeCount", this.article.likeCount - 1);
        } else {
          this.$set(this.article, "likeCount", this.article.likeCount + 1);
        }
        this.$store.commit("articleLike", this.article.id);
      });
    },
    markdownToHtml(article) {
      const MarkdownIt = require("markdown-it");
      const hljs = require("highlight.js");
      const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        highlight: function(str, lang) {
          // 当前时间加随机数生成唯一的id标识
          var d = new Date().getTime();
          if (
            window.performance &&
            typeof window.performance.now === "function"
          ) {
            d += performance.now();
          }
          const codeIndex = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function(c) {
              var r = (d + Math.random() * 16) % 16 | 0;
              d = Math.floor(d / 16);
              return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
            }
          );
          // 复制功能主要使用的是 clipboard.js
          let html = `<button class="copy-btn iconfont iconfuzhi" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}"></button>`;
          const linesLength = str.split(/\n/).length - 1;
          // 生成行号
          let linesNum = '<span aria-hidden="true" class="line-numbers-rows">';
          for (let index = 0; index < linesLength; index++) {
            linesNum = linesNum + "<span></span>";
          }
          linesNum += "</span>";
          if (lang && hljs.getLanguage(lang)) {
            // highlight.js 高亮代码
            const preCode = hljs.highlight(lang, str, true).value;
            html = html + preCode;
            if (linesLength) {
              html += '<b class="name">' + lang + "</b>";
            }
            // 将代码包裹在 textarea 中，由于防止textarea渲染出现问题，这里将 "<" 用 "<" 代替，不影响复制功能
            return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${str.replace(
              /<\/textarea>/g,
              "</textarea>"
            )}</textarea>`;
          }
        }
      });
      // 将markdown替换为html标签
      article.content = md.render(
        article.contentMd ? article.contentMd : article.content
      );
      this.article = article;
    },
    previewImg(img) {
      this.$imagePreview({
        images: this.imgList,
        index: this.imgList.indexOf(img)
      });
    },
    deleteHTMLTag(content) {
      return content
        .replace(/<\/?[^>]*>/g, "")
        .replace(/[|]*\n/, "")
        .replace(/&npsp;/gi, "");
    }
  },
  computed: {
    blogInfo() {
      return this.$store.state.blogInfo;
    },
    articleCover() {
      return (
        "background: url(" +
        this.article.avatar +
        ") center center / cover no-repeat"
      );
    },
    isLike() {
      var articleLikeSet = this.$store.state.articleLikeSet;
      return articleLikeSet.indexOf(this.article.id) != -1
        ? "like-btn-active"
        : "like-btn";
    },
    isFull() {
      return function(id) {
        return id ? "post full" : "post";
      };
    },
    // 摘要优先用库里的 summary，没有就从正文抽一段纯文本
    metaDescription() {
      const a = this.article || {};
      if (a.summary) return a.summary.slice(0, 150);
      const text = (a.content || "")
        .replace(/<h[1-6][^>]*>[\s\S]*?<\/h[1-6]>/g, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      return text ? text.slice(0, 150) : "穆雄雄的技术文章。";
    },
    metaKeywords() {
      const a = this.article || {};
      if (a.keywords) return a.keywords;
      const parts = [];
      if (a.title) parts.push(a.title);
      if (a.category && a.category.name) parts.push(a.category.name);
      (a.tagList || []).forEach(t => parts.push(t.name));
      parts.push("穆雄雄");
      return parts.join(",");
    },
    metaImage() {
      const a = this.article || {};
      const cover = a.avatar || "";
      if (!cover) return "https://www.88688.team/imgs/avatar/muxiongxiong.jpg";
      return cover.indexOf("http") === 0
        ? cover
        : "https://www.88688.team" + cover;
    }
  }
};
</script>

<style scoped>
/* ---- 页头与容器：不用老模板那套黑色大 banner ---- */
.post-head {
  background: var(--bg);
  border-bottom: 1px solid var(--border-soft);
  padding: 118px 24px 44px;
}
.post-head-inner {
  width: min(1140px, 94vw);
  max-width: 100%;
  margin: 0 auto;
}
.post-eyebrow {
  display: inline-block;
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--accent) !important;
  margin-bottom: 16px;
}
.post-title {
  font-size: 42px;
  line-height: 1.28;
  font-weight: 600;
  letter-spacing: -1.2px;
  color: var(--ink);
  margin: 0 0 20px;
}
.post-meta {
  display: flex;
  flex-wrap: wrap;
  font-size: 13.5px;
  color: var(--ink-faint);
}
.post-meta span {
  margin-right: 22px;
  white-space: nowrap;
}

.post-container {
  width: min(1140px, 94vw);
  max-width: 100%;
  margin: 28px auto 72px auto !important;
}
.post-wrapper {
  max-width: 780px;
  margin: 0 auto;
  padding: 20px 0 0;
}
/* 阅读态排版 */
.post-wrapper >>> .article-content {
  font-size: 16px;
  line-height: 2.05;
  color: var(--ink-mid);
}
.post-wrapper >>> .article-content h1,
.post-wrapper >>> .article-content h2,
.post-wrapper >>> .article-content h3,
.post-wrapper >>> .article-content h4 {
  color: var(--ink);
  font-weight: 600;
  letter-spacing: -0.3px;
  border: none;
  margin: 2.2em 0 0.8em;
}
.post-wrapper >>> .article-content h2 {
  font-size: 24px;
}
.post-wrapper >>> .article-content h3 {
  font-size: 19px;
}
.post-wrapper >>> .article-content p {
  margin-bottom: 1.1em;
}
.post-wrapper >>> .article-content img {
  border-radius: var(--radius);
  border: 1px solid var(--border-soft);
}
.post-wrapper >>> .article-content blockquote {
  border-left: 3px solid var(--accent);
  background: var(--bg-alt);
  color: var(--ink-mid);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}
.post-wrapper >>> .article-content pre {
  border-radius: var(--radius-sm);
}

@media (max-width: 959px) {
  .post-wrapper {
    padding: 10px 4px 0;
  }
}
@media (max-width: 760px) {
  .post-head {
    padding: 92px 20px 32px;
  }
  .post-title {
    font-size: 27px;
    letter-spacing: -0.6px;
  }
  .post-meta {
    font-size: 12.5px;
  }
  .post-meta span {
    margin-right: 14px;
  }
  .post-container {
    margin: 20px auto 30px auto !important;
  }
}

.post-tail {
  margin-top: 64px;
  padding-top: 28px;
  border-top: 1px solid var(--border-soft);
}
.back-story {
  font-size: 15px;
  font-weight: 500;
  color: var(--accent) !important;
}
.back-story:hover {
  color: var(--accent-deep) !important;
}

/*分享的内容*/
.fx_content {
  width: 70%;
  float: left;
  margin: 112% 0 0 5%;
}
/*整个海报*/
#posterHtml {
  background-repeat: no-repeat;
  width: 100%;
  height: 450px;
  background-size: 100% 450px;
  margin: 0;
  padding: 0;
}
/*二维码*/
#qrcodeImg {
  width: 25%;
  height: 150px;
  float: right;
  margin-top: 108%;
}

@media (min-width: 760px) {
  .banner {
    color: #eee !important;
  }

  .article-info span {
    font-size: 95%;
  }

  .article-info-container {
    position: absolute;
    bottom: 6.25rem;
    padding: 0 8%;
    width: 100%;
    text-align: center;
  }

  .second-line,
  .third-line {
    display: inline;
  }

  .article-title {
    font-size: 35px;
    margin: 20px 0 8px;
  }

  .pagination-post {
    display: flex;
  }

  .post {
    width: 50%;
  }

  .recommend-item {
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin: 3px;
    width: calc(33.333% - 6px);
    height: 200px;
    background: #000;
    vertical-align: bottom;
  }
}

@media (max-width: 759px) {
  .banner {
    color: #eee !important;
    height: 360px;
  }

  .article-info span {
    font-size: 90%;
  }

  .separator:first-child {
    display: none;
  }

  .blog-container {
    margin: 322px 5px 0 5px;
  }

  .article-info-container {
    position: absolute;
    bottom: 1.3rem;
    padding: 0 5%;
    width: 100%;
    color: #eee;
    text-align: left;
  }

  .article-title {
    font-size: 1.5rem;
    margin-bottom: 0.4rem;
  }

  .post {
    width: 100%;
  }

  .pagination-post {
    display: block;
  }

  .recommend-item {
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin: 3px;
    width: calc(100% - 4px);
    height: 150px;
    margin: 2px;
    background: #000;
    vertical-align: bottom;
  }
}

.article-content {
  word-break: break-word;
  font-size: 14px;
  line-height: 2;
}

.article-operation {
  display: flex;
  align-items: center;
}

.tag-container span {
  display: inline-block;
  margin: 0.5rem 0.5rem 0.5rem 0;
  padding: 0 0.85rem;
  border: 1px solid var(--border);
  background: var(--bg-alt);
  border-radius: 1rem;
  color: var(--ink-soft);
  font-size: 12.5px;
  line-height: 2.1;
}

.aritcle-copyright {
  position: relative;
  margin-top: 40px;
  margin-bottom: 10px;
  font-size: 0.875rem;
  line-height: 2;
  padding: 0.625rem 1rem;
  border: 1px solid #eee;
}

.aritcle-copyright span {
  color: #49b1f5;
  font-weight: bold;
}

.aritcle-copyright a {
  text-decoration: underline !important;
  color: #99a9bf !important;
}

.aritcle-copyright:before {
  position: absolute;
  top: 0.7rem;
  right: 0.7rem;
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
  background: #49b1f5;
  content: "";
}

.aritcle-copyright:after {
  position: absolute;
  top: 0.95rem;
  right: 0.95rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 0.5em;
  background: #fff;
  content: "";
}

.article-reward {
  margin-top: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reward-btn {
  position: relative;
  display: inline-block;
  width: 100px;
  background: #49b1f5;
  margin: 0 1rem;
  color: #fff !important;
  text-align: center;
  line-height: 36px;
  font-size: 0.875rem;
}

.reward-btn-share {
  position: relative;
  display: inline-block;
  width: 100px;
  background: lightgreen;
  margin: 0 0;
  color: #fff !important;
  text-align: center;
  line-height: 36px;
  font-size: 0.875rem;
}

.reward-btn:hover .reward-main {
  display: block;
}

.reward-main {
  display: none;
  position: absolute;
  bottom: 40px;
  left: 0;
  margin: 0;
  padding: 0 0 15px;
  width: 100%;
}

.reward-all {
  display: inline-block;
  margin: 0 0 0 -110px;
  padding: 20px 10px 8px !important;
  width: 320px;
  border-radius: 4px;
  background: var(--bg-alt);
}

.reward-all:before {
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
}

.reward-all:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 2px;
  left: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-top: 13px solid #f5f5f5;
  border-right: 13px solid transparent;
  border-left: 13px solid transparent;
}

.reward-item {
  display: inline-block;
  padding: 0 8px;
  list-style-type: none;
}

.reward-img {
  width: 130px;
  height: 130px;
  display: block;
}

.reward-desc {
  margin: -5px 0;
  color: #858585;
  text-align: center;
}

.like-btn {
  display: inline-block;
  width: 100px;
  background: #969696;
  color: #fff !important;
  text-align: center;
  line-height: 36px;
  font-size: 0.875rem;
}

.like-btn-active {
  display: inline-block;
  width: 100px;
  background: #ec7259;
  color: #fff !important;
  text-align: center;
  line-height: 36px;
  font-size: 0.875rem;
}

.pagination-post {
  margin-top: 40px;
  overflow: hidden;
  width: 100%;
  background: #000;
}

.post {
  position: relative;
  height: 150px;
  overflow: hidden;
}

.post-info {
  position: absolute;
  top: 50%;
  padding: 20px 40px;
  width: 100%;
  transform: translate(0, -50%);
  line-height: 2;
  font-size: 14px;
}

.post-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  transition: all 0.6s;
  object-fit: cover;
}

.post a {
  position: relative;
  display: block;
  overflow: hidden;
  height: 150px;
}

.post:hover .post-cover {
  opacity: 0.8;
  transform: scale(1.1);
}

.label {
  font-size: 90%;
  color: #eee;
}

.pagination-post .post-title {
  font-weight: 500;
  color: #fff;
}

hr {
  position: relative;
  margin: 40px auto;
  border: 2px dashed #d2ebfd;
  width: calc(100% - 4px);
}

.full {
  width: 100% !important;
}

.right-container {
  padding: 4px 0 4px 20px;
  font-size: 13.5px;
  border-left: 1px solid var(--border);
}

.right-title {
  font-size: 12.5px;
  letter-spacing: 2px;
  color: var(--ink-faint);
  margin-bottom: 10px;
}

.recommend-container {
  margin-top: 40px;
}

.recommend-title {
  font-size: 20px;
  line-height: 2;
  font-weight: bold;
  margin-bottom: 5px;
}

.recommend-cover {
  width: 100%;
  height: 100%;
  opacity: 0.4;
  transition: all 0.6s;
  object-fit: cover;
}

.recommend-info {
  line-height: 2;
  color: #fff;
  position: absolute;
  top: 50%;
  padding: 0 20px;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
  font-size: 14px;
}

.recommend-date {
  font-size: 90%;
}

.recommend-item:hover .recommend-cover {
  opacity: 0.8;
  transform: scale(1.1);
}

.article-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.article-item:first-child {
  padding-top: 0;
}

.article-item:last-child {
  padding-bottom: 0;
}

.article-item:not(:last-child) {
  border-bottom: 1px dashed #f5f5f5;
}

.article-item img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
  object-fit: cover;
}

.article-item img:hover {
  transform: scale(1.1);
}

.content {
  flex: 1;
  padding-left: 10px;
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.content-cover {
  width: 58.8px;
  height: 58.8px;
  overflow: hidden;
}

.content-title a {
  transition: all 0.2s;
  font-size: 95%;
}

.content-title a:hover {
  color: #2ba1d1;
}

.content-time {
  color: #858585;
  font-size: 85%;
  line-height: 2;
}
</style>

<style lang="scss">
pre.hljs {
  padding: 12px 2px 12px 40px !important;
  border-radius: 5px !important;
  position: relative;
  font-size: 14px !important;
  line-height: 22px !important;
  overflow: hidden !important;

  &:hover .copy-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  code {
    display: block !important;
    margin: 0 10px !important;
    overflow-x: auto !important;

    &::-webkit-scrollbar {
      z-index: 11;
      width: 6px;
    }

    &::-webkit-scrollbar:horizontal {
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      width: 6px;
      background: #666;
    }

    &::-webkit-scrollbar-corner,
    &::-webkit-scrollbar-track {
      background: #1e1e1e;
    }

    &::-webkit-scrollbar-track-piece {
      background: #1e1e1e;
      width: 6px;
    }
  }

  .line-numbers-rows {
    position: absolute;
    pointer-events: none;
    top: 12px;
    bottom: 12px;
    left: 0;
    font-size: 100%;
    width: 40px;
    text-align: center;
    letter-spacing: -1px;
    border-right: 1px solid rgba(0, 0, 0, 0.66);
    user-select: none;
    counter-reset: linenumber;

    span {
      pointer-events: none;
      display: block;
      counter-increment: linenumber;

      &:before {
        content: counter(linenumber);
        color: #999;
        display: block;
        text-align: center;
      }
    }
  }

  b.name {
    position: absolute;
    top: 7px;
    right: 45px;
    z-index: 1;
    color: #999;
    pointer-events: none;
  }

  .copy-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
    color: #ccc;
    background-color: #525252;
    border-radius: 6px;
    display: none;
    font-size: 14px;
    width: 32px;
    height: 24px;
    outline: none;
  }
}
</style>
